module.exports = __webpack_public_path__ + "static/media/service.3e115b44.svg";